<script>
import { mapActions } from "vuex";
export default {
  name: "verify-email",

  data() {
    return {
      preloader: false,
      invalid: false,
      valid: false,
      seconds: 8
    };
  },

  methods: {
    ...mapActions("user", ["verifyEmail"]),

    descreaseSeconds() {
      this.seconds--;
      if (!this.seconds) this.$router.push({ name: "purchase-flow" });
    },

    async send() {
      this.preloader = true;

      try {
        let res = await this.verifyEmail(this.$route.query.token);
        this.valid = true;

        setInterval(() => {
          this.descreaseSeconds();
        }, 1000);
      } catch (e) {
        this.invalid = true;
      }

      this.preloader = false;
    }
  },

  mounted() {
    this.send();
  }
};
</script>

<template>
  <div class="container-center">
    <div class="box">
      <div v-if="invalid">
        <img class="mb-30" src="/static/icon-error.svg" height="80px" alt="broom" />
        <b>Ocorreu um erro!</b>
        O token informado não é valido.
      </div>

      <div v-if="valid">
        <img class="mb-30" src="/static/icon-success.svg" height="80px" alt="broom" />
        <b>Seu e-mail foi verificado com sucesso!</b>
        Agora você já pode realizar compras na nossa plataforma.
        <br />
        <p>
          Você será redirecionado em
          <b>{{seconds}} segundos</b>.
        </p>
      </div>

      <div v-if="preloader" class="preloader">
        <img src="/static/broom.gif" alt="broom" />
        <b>Aguarde,</b>
        Estamos verificando a sua conta de e-mail.
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  margin: 20px 0 0;
  color: var(--purple);
}

.box div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.preloader img {
  border-radius: 100%;
  border: 5px solid #fff;
  box-shadow: 0 0 0 10px var(--pink);
  margin-bottom: 50px;
}

.container-center {
  background: #ededed;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.box {
  width: 440px;
  margin-top: -25px;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .box {
    width: 340px;
  }
}

@media (max-width: 480px) {
  .box {
    width: 200px;
    margin-top: -25px;
  }
}

@media (max-width: 320px) {
  .box {
    width: 190px;
    margin-top: -43px;
    padding: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VerifyEmail.vue